<template>
    <div class="pie">

        <div class="headline" v-if="headline">
            {{ headline }}
        </div>

        <vue-apex-charts
            :options="chartOptions"
            :series="series"
            :labels="labels"
            :height="chartOptions.chart.height"
        />

        <div class="total" v-if="total > 0">
            I alt {{ total | rounded }} timer
        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars.scss";

    .headline {
        font-size: $fontsize--main;
        font-weight: 600;
        margin-bottom: $margin--small;
        text-align: center;
        font-family: $fontfamily--secondary;
    }

    .total {
        text-align: center;
        font-size: $fontsize--small;
        color: $color--grey;
        margin-top: $margin--small;
    }

</style>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: {
        headline: { type: String, default: '' },
        series: { type: Array, default: () => [] },
        labels: { type: Array, default: () => [] },
        division: { type: Boolean, default: false },
        height: { type: String, default: '300px' }
    },
    data () {
        return {
            chartOptions: {
                series: [],
                labels: this.labels ? this.labels : null,
                colors: this.division === true ? ['#4CAF50', '#FFC107', '#E57373', '#9E9E9E'] : this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: this.height
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: (value) => {
                            let percent = Math.round((value / this.total) * 100)
                            return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return this.$options.filters.rounded(val) + ' %'
                    }
                },
                legend: {
                    show: false,
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false,
                                value: {
                                    formatter: (value) => {
                                        let percent = Math.round((value / this.total) * 100)
                                        return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    components: {
        VueApexCharts
    },
    computed: {
        total () {
            let count = 0
            this.series.forEach((item) => {
                count += item
            })
            return count
        }
    }
}
</script>



// WEBPACK FOOTER //
// pie.vue?16b83ce6